import * as fns from 'date-fns';
import { employmentType, maxImageSize } from '../../../common/constants/Constants';
import { DateHelper, Utils } from '../../../common/helper';
export const getLabelFromString = (data) => (Utils.isNotNull(data) ? data : '-');
export const getNumber = (data) => (Utils.isNotNull(data) ? data : 0);
export const getLabelFromTimestamp = (data, isDateOnly = true) => Utils.isNotNull(data)
    ? isDateOnly
        ? DateHelper.toStringDateOnly(data.toDate())
        : DateHelper.toString(data.toDate())
    : '-';
export const getDurationTimestamp = (a, b, format = 'HH:mm') => {
    if (Utils.isNotNull(a) && Utils.isNotNull(b)) {
        return getDurationDate(a.toDate(), b.toDate(), '~', format);
    }
    return '-';
};
export const getDurationDate = (a, b, durationStr, format) => `${fns.format(a, format)}${durationStr}${fns.format(b, format)}`;
export const getLabelWorkingDate = (employmentId, a, b) => {
    return employmentId === employmentType.partTimeShort
        ? getDurationTimestamp(a, b, 'yyyy/MM/dd')
        : getLabelFromTimestamp(a);
};
export const getLabelWorkingTime = (employmentId, a, b) => {
    return employmentId === employmentType.partTimeOneDay ? getDurationTimestamp(a, b) : '-';
};
export const getLabelRecruitment = (t, data) => {
    if (Utils.isNotNull(data)) {
        return data ? t('募集中') : t('募集停止');
    }
    return t('募集停止');
};
export const getLabelEmployment = (masterList, data) => {
    if (Utils.isNotNull(data)) {
        const result = masterList.find((item) => item.id === data);
        if (Utils.isNotNull(result)) {
            return result.text;
        }
    }
    return '-';
};
export const getLabelReward = (masterList, rewardType, amount) => {
    if (Utils.isNotNull(rewardType)) {
        const result = masterList.find((item) => item.id === rewardType);
        if (Utils.isNotNull(result)) {
            return `${result.text} ${getNumber(amount).toLocaleString()}`;
        }
    }
    return '-';
};
export const getLabelPaidReward = (amount) => {
    return Utils.isNotNull(amount) ? `${getNumber(amount).toLocaleString()}` : '';
};
export const getLabelModifiedAmount = (amount) => {
    return Utils.isNotNull(amount) ? `${getNumber(amount).toLocaleString()}` : '';
};
export const getLabelPaymentsType = (masterList, data) => {
    if (Utils.isNotNull(data)) {
        const result = masterList.filter((item) => { var _a; return (_a = data) === null || _a === void 0 ? void 0 : _a.includes(item.id); });
        if (Utils.isNotNull(result)) {
            const texts = result.map((item) => item.text);
            return texts.join('/');
        }
    }
    return '-';
};
export const getLabelApprovalStatus = (t, isApproval) => {
    if (Utils.isNotNull(isApproval)) {
        return isApproval ? t('承認済') : t('否認済');
    }
    return '';
};
export const getLabelPlanPeriod = (t, periodNum) => {
    let label = '';
    switch (periodNum) {
        case 1:
            label = t('月額');
            break;
        case 12:
            label = t('年間');
            break;
        default:
            break;
    }
    return label;
};
export const getLabelPlanConstantCost = (amount) => {
    return Utils.isNotNull(amount) ? `${getNumber(amount).toLocaleString()}` : '';
};
export const isCashOnly = (payments) => {
    var _a;
    if (Utils.isNotNull(payments)) {
        if (((_a = payments) === null || _a === void 0 ? void 0 : _a.length) === 1 && payments[0] === 0)
            return true;
    }
    return false;
};
export const isPartTimeOneDay = (employmentId) => {
    return employmentId === employmentType.partTimeOneDay;
};
export const isJobOfferBadge = (jobOffer) => {
    if (Utils.isNotNull(jobOffer.jobAppliedCount) && Utils.isNotNull(jobOffer.applyCheckedCount)) {
        return jobOffer.jobAppliedCount > jobOffer.applyCheckedCount ? true : false;
    }
    return false;
};
export const isNotImageFile = (mimeType) => {
    var _a;
    const type = (_a = mimeType.split('/').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return type !== 'jpeg' && type !== 'jpg' && type !== 'png' && type !== 'bmp' && type !== 'gif';
};
export const isOverFileSize = (file) => {
    return file.size > maxImageSize;
};
